import PropTypes from 'prop-types';
export const sectionHeadingPropTypes = {
  /**
   * Heading
   */
  heading: PropTypes.string,
  /**
   * Description
   */
  description: PropTypes.string,
  /**
   * Additional classname
   */
  classname: PropTypes.string
};